
export type DirectionGuideItem={
  id:string;
  shortLabel:string;
  fullLabel:string;
  zhLabel:string;
  question:string;
  groupId:string;
};

export type DirectionGroup={
  id:string;
  label:string;
  summary:string;
  directionIds:string[];
};

export const directionGroups:DirectionGroup[]=[
  {
    id:"material-physics",
    label:"Material physics",
    summary:"Where polarization selectivity originates.",
    directionIds:["D1","D2"],
  },
  {
    id:"device-structure",
    label:"Device & structure",
    summary:"How selectivity is engineered into device functions.",
    directionIds:["D3","D4"],
  },
  {
    id:"imaging-computation",
    label:"Imaging & computation",
    summary:"How polarization states become images and reconstructed information.",
    directionIds:["D5","D6"],
  },
  {
    id:"intelligence-applications",
    label:"Intelligence & applications",
    summary:"How sensing merges with computing and deployable systems.",
    directionIds:["D7","D8"],
  },
];

export const directionGuide:Record<string,DirectionGuideItem>={
  D1:{
    id:"D1",
    shortLabel:"Intrinsic anisotropy",
    fullLabel:"Intrinsically Anisotropic Materials and Linear Polarization Detection",
    zhLabel:"本征各向异性材料与线偏振探测",
    question:"Can the material itself distinguish linear polarization?",
    groupId:"material-physics",
  },
  D2:{
    id:"D2",
    shortLabel:"Chirality",
    fullLabel:"Chiral Materials and Circular Polarization Detection",
    zhLabel:"手性材料与圆偏振探测",
    question:"Can material handedness directly distinguish circular polarization?",
    groupId:"material-physics",
  },
  D3:{
    id:"D3",
    shortLabel:"Heterojunction devices",
    fullLabel:"Heterojunction and Multifunctional Polarization Devices",
    zhLabel:"异质结与多功能偏振器件",
    question:"How can interfaces combine polarization selectivity with device functions?",
    groupId:"device-structure",
  },
  D4:{
    id:"D4",
    shortLabel:"Metasurfaces & integration",
    fullLabel:"Artificial Structures, Metasurfaces and Integrated Polarization Detection",
    zhLabel:"人工结构、超表面与集成偏振探测",
    question:"How can artificial structures encode polarization on-chip?",
    groupId:"device-structure",
  },
  D5:{
    id:"D5",
    shortLabel:"Arrays & Full-Stokes",
    fullLabel:"Arrays, Full-Stokes and Multidimensional Polarization Imaging",
    zhLabel:"阵列、全 Stokes 与多维偏振成像",
    question:"How can complete polarization states be measured across pixels and dimensions?",
    groupId:"imaging-computation",
  },
  D6:{
    id:"D6",
    shortLabel:"Computational imaging",
    fullLabel:"Computational Polarization Imaging and AI Vision",
    zhLabel:"计算偏振成像与 AI 视觉",
    question:"What can algorithms reconstruct or infer beyond raw detector outputs?",
    groupId:"imaging-computation",
  },
  D7:{
    id:"D7",
    shortLabel:"Neuromorphic sensing",
    fullLabel:"Bioinspired, Neuromorphic and In-Sensor Polarization Computing",
    zhLabel:"仿生、神经形态与传感器内偏振计算",
    question:"Can polarization sensing and computing merge inside the sensor?",
    groupId:"intelligence-applications",
  },
  D8:{
    id:"D8",
    shortLabel:"Application systems",
    fullLabel:"Polarization Detection Application Systems",
    zhLabel:"偏振探测应用系统",
    question:"How do polarization capabilities become deployable real-world systems?",
    groupId:"intelligence-applications",
  },
};

export const progressionNote=
  "Conceptual reading stack only — not chronology, influence, or causality.";
